import { Box, Skeleton } from '@bonanza-social/moonlight';

function InboxSkeleton() {
  return (
    <Box padding="space-600" gap="space-400">
      <Box gap="space-200" flexDirection="row">
        <Skeleton height={65} width={65} />
        <Box flex={1} justifyContent="center">
          <Skeleton height={65} width="100%" />
        </Box>
      </Box>
      <Box gap="space-200" flexDirection="row">
        <Skeleton height={65} width={65} />
        <Box flex={1} justifyContent="center">
          <Skeleton height={65} width="100%" />
        </Box>
      </Box>
      <Box gap="space-200" flexDirection="row">
        <Skeleton height={65} width={65} />
        <Box flex={1} justifyContent="center">
          <Skeleton height={65} width="100%" />
        </Box>
      </Box>
    </Box>
  );
}

export default InboxSkeleton;
